import { useTranslation } from 'react-i18next'
import {
  CompareGroupType,
  GroupsCompareTypesConfig,
  PrivateReportsGroupsCompareTypesConfig,
} from '../configs/StudiesObjectsCompareGroupTypesConfig'
import { CompareGroupValueType } from '../../../../../store/interfaces/analytics-details/new-readership-profile-state.interface'
import { SetColorConfig } from '../../../../../core/config/SetColorConfig'
import { BookInterface } from '../../../../../core/interface/book.interface'
import ReadershipProfileInputTypeChoice from './ReadershipProfileInputTypeChoice'
import { DateFilterTypeEnum } from '../../../../../core/enums/date-filter-type.enum'
import NewReadershipProfileBookFiltersInterface from '../../../../../core/interface/analytics/new-readership-profile-book-filters'

const GroupCompareSelection = ({
  disable,
  compareGroupType,
  handleOnClickInputSelectionButton,
  compareGroupValue,
  handleSelectValue,
  booksSelected,
  handleUpdateBooksSelected,
  handleOpenBookDetails,
  eanSelected,
  filtersActions,
  handleOnChangeFilter,
  isPrivate = false,
}: {
  disable: boolean
  compareGroupType: CompareGroupType
  compareGroupValue: CompareGroupValueType
  handleOnClickInputSelectionButton: (value: CompareGroupType) => void
  handleSelectValue: (value: CompareGroupValueType) => void
  booksSelected: BookInterface[]
  handleUpdateBooksSelected: (books: BookInterface[]) => void
  handleOpenBookDetails: (eanId: number | null) => void
  eanSelected: number | null
  filtersActions: NewReadershipProfileBookFiltersInterface
  handleOnChangeFilter: (
    key: string | number,
    newList: Array<string | number | null> | DateFilterTypeEnum,
  ) => void
  isPrivate?: boolean
}) => {
  const { t } = useTranslation()
  return (
    <ReadershipProfileInputTypeChoice<CompareGroupType, CompareGroupValueType>
      disable={disable}
      color={SetColorConfig[0].color2}
      keyValue="compare-group"
      title={t('inComparisonWithThoseOfNew')}
      subTitle={t('ComparisonGroup')}
      inputsTypeConfig={
        isPrivate
          ? PrivateReportsGroupsCompareTypesConfig
          : GroupsCompareTypesConfig
      }
      inputTypeSelected={compareGroupType}
      inputValue={compareGroupValue}
      handleOnClickInputSelectionButton={handleOnClickInputSelectionButton}
      handleSelectValue={handleSelectValue}
      booksSelected={booksSelected}
      handleUpdateBooksSelected={handleUpdateBooksSelected}
      handleOpenBookDetails={handleOpenBookDetails}
      eanSelected={eanSelected}
      filtersActions={filtersActions}
      handleOnChangeFilter={handleOnChangeFilter}
      isPrivate={isPrivate}
    />
  )
}
export default GroupCompareSelection
